module.exports = __webpack_public_path__ + "static/media/critical-badge.272b1e0f.svg";